/* © Facilogi. See LICENSE file for full copyright & licensing details. */

import { $t } from "App/IOC";
import { Column, CustomError } from "App/Models";
import Columns from "App/UseCases/Columns";

let sort: Column;
let columns: Column[] = [];

function GetDefaultSort(): Column {
    /* To avoid an issue with $t being empty because it has yet to be injected to Ioc because if
       we put this instantiation at the module level here, it will get executed during
       node module importation step, which is before we inject the actual $t() implementation into
       our Ioc (Through Web/Main.ts), so we wrap it in a funtion. */
    if( sort === undefined )
        sort = new Column( "CreatedAt", $t( "SUBSCRIPTIONS_columnCreatedAt" ), "dateTime" );

    return sort;
}

function getDefault(): Column[] {
    if( columns.length === 0 )
        columns = [
            new Column( "CustomerCompany", $t( "CUSTOMERS_columnCompany" ) ),
            new Column( "CustomerEmail", $t( "SUBSCRIPTIONS_columnCustomerEmail" ) ),
            new Column( "CustomerName", $t( "CUSTOMERS_columnName" ) ),
            new Column( "Status", $t( "SUBSCRIPTIONS_columnState" ), "SubscriptionStatus" ),
            new Column( "Plans", $t( "SUBSCRIPTIONS_columnLines" ), "SubscriptionPlans" ),
            new Column( "Recurrence", $t( "SUBSCRIPTIONS_columnRecurrence" ) ),
            GetDefaultSort(),
            new Column( "UpdatedAt", $t( "SUBSCRIPTIONS_columnUpdatedAt" ), "dateTime" ),
            new Column( "MonthlyTotal", $t( "SUBSCRIPTIONS_columnMonthlyTotal" ) ),
            new Column( "YearlyTotal", $t( "SUBSCRIPTIONS_columnYearlyTotal" ) )
        ];

    return columns;
}

async function Get(): Promise<[ Column[], CustomError | undefined ]> {
    return await Columns.Get( "Customers", getDefault() );
}

// function GetMapping(): Dictionary<string> {
//     return { ...Fields.GetMapping() };
// }

async function Toggle( existingColumn: Column ): Promise<CustomError | undefined> {
    return await Columns.Toggle( "Customers", existingColumn, getDefault() );
}

export default {
    GetDefaultSort,
    Get,
    // GetMapping,
    Toggle
};
